import styled from 'styled-components';

export const Container = styled.div<{ $fullPage?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${({ $fullPage, theme }) => $fullPage && `
    min-height: 100vh;
    background-color: ${theme.colors.pageBackground};
  `}
  ${({ $fullPage, theme }) => !$fullPage && `
    padding: ${theme.spacing.xl} ${theme.spacing.md};
  `}
`;

export const IconWrapper = styled.div`
  font-size: 64px;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  opacity: 0.3;
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const Description = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  color: ${({ theme }) => theme.colors.text.tertiary};
  line-height: 1.5;
`;
